export default "__VITE_ASSET__BK8cH28q__"